var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4Players(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ARTWORK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.54,14V11.41L10.68,3h3.55v8.78h.94V14h-.94v2H11.89V14Zm2-2.25h1.38V6.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.53,20v1H6.94V18h.87a.48.48,0,0,1,.55.54v.83a.49.49,0,0,1-.55.55Zm.24-1.31a.1.1,0,0,0-.11-.11H7.53v.92h.13a.1.1,0,0,0,.11-.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.52,18h.59v2.42h.43V21h-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.8,18,11.19,21H10.6l0-.43h-.37l0,.43H9.61L10,18Zm-.43.71L10.24,20h.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.86,19l.21-1h.56l-.5,1.9v1h-.58V20L11.05,18h.61Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.72,18h1.1v.52h-.51v.66h.49v.53h-.49v.71h.52V21H12.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.19,19.58a.35.35,0,0,1,.26.38v1h-.59V20c0-.07,0-.1-.1-.1h-.15V21H14V18h.88a.48.48,0,0,1,.55.54v.57A.42.42,0,0,1,15.19,19.58Zm-.33-.94c0-.07,0-.1-.11-.1h-.14v.82h.14a.1.1,0,0,0,.11-.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.82,19.45a.46.46,0,0,1,.24.46v.54a.49.49,0,0,1-.55.55h-.33a.48.48,0,0,1-.55-.55v-.63h.58v.58c0,.07,0,.1.1.1h.06c.07,0,.1,0,.1-.1V20a.23.23,0,0,0-.1-.19l-.5-.37a.7.7,0,0,1-.19-.2.67.67,0,0,1,0-.26v-.47a.48.48,0,0,1,.55-.55h.32a.49.49,0,0,1,.55.55v.54h-.58V18.6c0-.07,0-.1-.11-.1h0c-.07,0-.11,0-.11.1v.28a.24.24,0,0,0,.1.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Players);
export default __webpack_public_path__ + "static/media/4_players.5f4cd4e88f3ddfb860f98f67003d2159.svg";
export { ForwardRef as ReactComponent };